import { BaseResourceApiService } from '@shared/services/BaseResourceApiService';
import { AUTOCALLER_URL } from '@shared/helpers/env';
class OperatorsServiceClass extends BaseResourceApiService {
  constructor(opts) {
    super(opts);
  }
  getList(params) {
    return super.getList({ ...params });
  }
  createItem(params) {
    return this.pure_http.post('/operators', params);
  }
  getItem(id) {
    return this.http.get(`/${id}`)
  }
  editItem(id, params = {}) {
    return this.http.put(`/${id}`, params);
  }
}

export const OperatorsService = new OperatorsServiceClass({
  api_version: 1,
  base_url: AUTOCALLER_URL,
  resource: 'operators'
});
